import React, { useContext, useEffect, useState } from 'react';
import {
  PrimaryButton, SecondaryButton,
  BaseButton, ConfirmButton,
  EndButton, ContrastButton
} from '../Buttons/Buttons';
import { fileToDataUrl } from '../../utils/helpers';
import styles from './GameCard.module.css';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { StoreContext } from '../../utils/store';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { BiImageAdd } from 'react-icons/bi';
import { ImCross } from 'react-icons/im';
import { Dropdown } from '../Dropdown/Dropdown';

export const GameCard = ({ id, gameDelete, setGameDelete }) => {
  const history = useHistory();
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;

  // control states
  const [sessionStarted, setSessionStarted] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [thumbnailUpdated, setThumbnailUpdated] = useState(0);

  // quiz states
  const [imageSrc, setImageSrc] = useState('');
  const [quiz, setQuiz] = useState({
    questions: [],
  });

  // api call functions
  const updateGame = async (q) => {
    const response = await api.makeAPIRequest(`admin/quiz/${id}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        questions: q.questions,
        thumbnail: q.thumbnail,
        name: q.name,
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setThumbnailUpdated(t => t + 1);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const deleteGame = async (e) => {
    const response = await api.makeAPIRequest(`admin/quiz/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setGameDelete(!gameDelete);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const getQuiz = async () => {
    const response = await api.makeAPIRequest(`admin/quiz/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json;
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const endSession = async () => {
    console.log('end session', quiz.active);
    const response = await api.makeAPIRequest(`admin/quiz/${id}/end`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        const bodyStyles = {
          positon: 'relative',
        }
        const textStyles = {
          fontSize: '1.2em',
          marginBlockStart: '0',
        }
        const buttonStyles = {
          marginLeft: '5px',
        };
        const buttonContainerStyles = {
          position: 'absolute',
          right: '10px',
          bottom: '5px',
        };
        setSessionStarted(false);
        setSessionId('');
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Session Ended!',
          modalBodyText:
            <div style={bodyStyles}>
              <p style={textStyles}>Would you like to view the results?</p>
              <div style={buttonContainerStyles}>
                <PrimaryButton
                  aria-label='see-result'
                  style={buttonStyles}
                  onClick={() => {
                    history.push('/game/result/' + sessionId);
                    setModalStatus(status => ({
                      ...status,
                      modalActive: false,
                      overlayActive: false,
                      modalBodyText: <></>,
                    }));
                  }}
                >
                  Yes
              </PrimaryButton>
                <SecondaryButton
                  aria-label='cancel'
                  style={buttonStyles}
                  onClick={() => {
                    setModalStatus(status => ({
                      ...status,
                      modalActive: false,
                      overlayActive: false,
                      modalBodyText: <></>,
                    }));
                  }}
                >
                  No
              </SecondaryButton>
              </div>
            </div>,
          modalColors: 'notification',
        }));
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };
  const startSession = async () => {
    console.log('start session');
    const response = await api.makeAPIRequest(`admin/quiz/${id}/start`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setSessionStarted(true);
        const newSessionId = await getSessionId();
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Session Started!',
          modalBodyText: newSessionId,
          modalColors: 'success',
        }));
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const getSessionId = async () => {
    const response = await api.makeAPIRequest(`admin/quiz/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json.active;
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  // calculate total time for a quiz
  const getTotalTime = () => {
    let time = 0;
    quiz.questions.forEach(q => (time += parseInt(q.timeLimit, 10)));
    return time;
  };

  // thumbnail control
  const updateImageSrc = async (e) => {
    const src = await fileToDataUrl(e.target.files[0]);
    console.log(e.target.files);
    setImageSrc(src);
    const newQuiz = { ...quiz };
    newQuiz.thumbnail = src;
    await updateGame(newQuiz);
  };

  const removeImage = async () => {
    setImageSrc('')
    const response = await api.makeAPIRequest(`admin/quiz/${id}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        thumbnail: 'NULL',
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setThumbnailUpdated(t => t + 1);
        // console.log('delete thumbnail');
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  // quiz set up
  useEffect(async () => {
    const q = await getQuiz();
    console.log(q);
    setQuiz(q);
    setSessionId(q.active);
    setImageSrc(q.thumbnail);
    if (q.active) setSessionStarted(true);
  }, [id, sessionStarted, thumbnailUpdated]);

  // copy click show modal
  const onCopyLink = () => {
    setModalStatus(status => ({
      ...status,
      modalActive: true,
      overlayActive: true,
      modalHeaderText: 'Copied!',
      modalBodyText: `Link https://qinjianzheng.github.io/BigBrain/play/join/${sessionId}/${id} is copied`,
      modalColors: 'success',
    }));
  };

  const toEditGamePage = () => {
    history.push('/game/' + id);
  };

  return (
    <div className={styles.card}>
      {/* Thumbnail */}
      <div
        className={styles.thumbnail}>
        {imageSrc && imageSrc !== 'NULL'
          ? <>
              <img
                className={styles.img}
                src={imageSrc}
                alt='question thumbnail' />
              <ImCross
                className={styles.removeButton}
                onClick={removeImage}
              />
            </>
          : <>
              <label htmlFor={`add-image${id}`}>
                <BiImageAdd className={styles.addImageIcon} />
              </label>
              <input
                type='file'
                id={`add-image${id}`}
                file={imageSrc}
                onChange={updateImageSrc}
                hidden />
            </>
        }
        <span className={styles.questionNum}>{quiz.questions.length} Question</span>
      </div>

      <div className={styles.info}>
        <div className={styles.rightTopContainer}>
          <h3 label='game-name'>{quiz.name}</h3>
          <div className={styles.gameStatus}>
            {sessionStarted
              ? <>
                <div className={styles.gameButtons}>
                  <EndButton
                    aria-label='end-game'
                    className={styles.button}
                    onClick={endSession}
                  >
                    End
                </EndButton>
                  <ContrastButton
                    aria-label='lobby'
                    className={styles.button}
                    onClick={() => history.push(`/lobby/${sessionId}/${id}/0`)}
                  >
                    Lobby
                  </ContrastButton>
                </div>
                <CopyToClipboard text={`https://qinjianzheng.github.io/BigBrain/play/join/${sessionId}/${id}`} onCopy={onCopyLink}>
                  <BaseButton
                    aria-label='copy-join-link'
                    className={styles.copyButton}
                    onClick={() => console.log(sessionId)}
                  >
                    Copy Link to Join
                  </BaseButton>
                </CopyToClipboard>

              </>
              : <ConfirmButton
                aria-label='start-game'
                className={styles.confrimButton}
                onClick={startSession}
              >
                Start
                </ConfirmButton>
            }
          </div>
        </div>
        <div className={styles.metadata}>
          <span>{getTotalTime()} Seconds</span>
          <div className={styles.buttons}>
              <PrimaryButton
                className={styles.button}
                onClick={toEditGamePage}
              >
                <span>Edit</span>
              </PrimaryButton>
            <SecondaryButton
              className={styles.button}
              onClick={deleteGame}
            >
              <span>Delete</span>
            </SecondaryButton>
          </div>
          <Dropdown
            deleteGame={deleteGame}
            toEditGamePage={toEditGamePage}
          />
        </div>
      </div>
    </div>
  );
};

GameCard.propTypes = {
  id: PropTypes.number,
  gameDelete: PropTypes.bool,
  setGameDelete: PropTypes.func,
};
